import React from 'react';
import { Container } from 'common/components';
import { MainInfo, MainPageLink, MainSection } from './components';

export type MainScreenProps = {
	title: string;
	basePhotoUrl: string;
	additionalText: string;
};

export const MainScreen = (props: MainScreenProps) => (
	<MainSection>
		<Container>
			<MainPageLink link="/uslugi/" />
			<MainInfo {...props} />
		</Container>
	</MainSection>
);
